import PageSectionWrapper from '../../components/PageSectionWrapper'
import { pageCategoryPageV3 } from '../../types/Contentful/ContentfulTypes'
import { BFFPageData } from '../../services/serviceClients/BffClient'
import { getRegisteredTest } from './testRegistry'
import { formatLocale } from '../../utils/buildHelpers'
import { BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_2 } from '../../constants/businessCardIncrementExperiment'

export interface ExperimentData {
  [key: string]: {
    variationKey?: string
    [key: string]: any
  }
}
const getActiveExperiments = (experimentData: ExperimentData) => {
  return Object.keys(experimentData).filter((experimentKey) => !!experimentData[experimentKey]?.variationKey)
}

export const TestSection = (experimentData: ExperimentData, sectionType: string) => {
  const activeExperimentKeys = getActiveExperiments(experimentData)

  for (const experimentKey of activeExperimentKeys) {
    const variationKey = experimentData[experimentKey]?.variationKey
    const registeredTest = variationKey ? getRegisteredTest(experimentKey, variationKey) : undefined
    const sectionOverride = (registeredTest || []).find((test) => test.sectionType === sectionType)
    if (sectionOverride && experimentData.isPageSection) {
      return sectionOverride.component
    }
  }
}

export const addNewTestSections = (props: {
  experimentData: ExperimentData
  sections: (false | JSX.Element | null | undefined | '')[]
  pageDataFromBFF: BFFPageData
  pageCategoryPageV3: pageCategoryPageV3
  locale: string
  experiments: Record<string, string | undefined>
  merchandisingCategoryId: string
  isPartOfSigninTreatment: boolean
}) => {
  const { experimentData, sections, pageDataFromBFF, pageCategoryPageV3, experiments, merchandisingCategoryId, locale, isPartOfSigninTreatment } = props
  const activeExperimentKeys = getActiveExperiments(experimentData)
  let updatedSections = [...sections]
  for (const experimentKey of activeExperimentKeys) {
    const variationKey = experimentData[experimentKey]?.variationKey
    const isPageSection = experimentData[experimentKey]?.isPageSection ?? true
    const registeredTest = variationKey ? getRegisteredTest(experimentKey, variationKey) : undefined
    const sectionOverride = (registeredTest || []).find((test) => !!test.position)
    const displayTestComponent = sectionOverride?.mcIds?.includes(merchandisingCategoryId!) && sectionOverride?.locales?.includes(formatLocale(locale, true))
    const sectionIdsToRemove = sectionOverride?.sectionIdsToRemove?.[formatLocale(locale, true)] || []
    updatedSections = updatedSections.filter((section) => {
      if (sectionIdsToRemove.length > 0 && (section as JSX.Element)?.props?.children.props.id) {
        const sectionId = (section as JSX.Element)?.props?.children.props.id
        return !sectionIdsToRemove.includes(sectionId!)
      }
      return true
    })

    if (sectionOverride && displayTestComponent) {
      const position = sectionOverride.position!
      const NewSection = sectionOverride.component
      const sectionProps = { pageDataFromBFF, pageCategoryPageV3 }

      const WrappedNewSection = isPageSection ? (
        <PageSectionWrapper key={`test-section-${position}-${experimentKey}`}>
          <NewSection {...sectionProps} />
        </PageSectionWrapper>
      ) : (
        <NewSection {...sectionProps} />
      )
      updatedSections.splice(position, 0, WrappedNewSection)
    }
  }

  for (const experimentKey of Object.keys(experiments)) {
    const variationKey = experiments[experimentKey]
    const isPageSection = true
    const registeredTest = variationKey ? getRegisteredTest(experimentKey, variationKey) : undefined
    const matchingOverrides = (registeredTest || []).filter(
      (test) => !!test.position && test?.mcIds?.includes(merchandisingCategoryId!) && test?.locales?.includes(formatLocale(locale, true)),
    )

    for (const override of matchingOverrides) {
      const sectionIdsToRemove = override?.sectionIdsToRemove?.[formatLocale(locale, true)] || []
      if (sectionIdsToRemove.length > 0) {
        updatedSections = updatedSections.filter((section) => {
          const sectionId = (section as JSX.Element)?.props?.children?.props?.id
          return !sectionId || !sectionIdsToRemove.includes(sectionId)
        })
      }
      let position = override.position!
      const NewSection = override.component
      const sectionProps = { pageDataFromBFF, pageCategoryPageV3 }
      const WrappedNewSection = isPageSection ? (
        <PageSectionWrapper key={`test-section-${position}-${experimentKey}-${override.sectionType}`}>
          <NewSection {...sectionProps} />
        </PageSectionWrapper>
      ) : (
        <NewSection {...sectionProps} />
      )
      if (experiments[experimentKey] === BUSINESS_CARDS_INCREMENT_EXPERIMENT_VARIATION_2 && override.sectionType === 'design template') {
        if (isPartOfSigninTreatment) {
          position = formatLocale(locale, true) === 'en-US' ? 5 : 4
        }
      }
      updatedSections.splice(position, 0, WrappedNewSection)
    }
  }

  return updatedSections
}
